import * as types from "./types";
import handleResponse from "../../shared/handleResponse";

export type Widget = {
  uuid: string;
  label: string;
  price: number;
};
type WidgetProps = { widgets: Array<Widget> };

const setLoading = (value: boolean): object => ({
  type: types.SET_LOADING,
  payload: value,
});

const setWidgets = (widgets: Array<Widget>) => ({
  type: types.SET_WIDGETS,
  payload: widgets,
});

const widgetSuccess = (dispatch: Function) => ({ widgets }: WidgetProps) => {
  dispatch(setWidgets(widgets));
};

export const getWidgets = (query: string) => async (dispatch: Function) => {
  dispatch(setLoading(true));
  const onSuccess = widgetSuccess(dispatch);
  await handleResponse("get", "/widgets", onSuccess, dispatch, {
    url: window.location.hostname,
  });
  dispatch(setLoading(false));
};
